import { createSlice } from "@reduxjs/toolkit";

const snackBarSlice = createSlice({
  name: "snackBarSlice",
  initialState: { severity: "", message: "", open: false },
  reducers: {
    displaySnackBar: (state, { payload }) =>
      (state = { ...payload, open: true }),
    closeSnackBar: state => {
      state.open = false;
    }
  }
});

export const { displaySnackBar, closeSnackBar } = snackBarSlice.actions;

export default snackBarSlice;
